module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cvw4H"))).then(() => parcelRequire('ljYL6'));